import { render, staticRenderFns } from "./AddWorkSamplesToContractor.vue?vue&type=template&id=33b558f0"
import script from "./AddWorkSamplesToContractor.vue?vue&type=script&lang=ts"
export * from "./AddWorkSamplesToContractor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b558f0')) {
      api.createRecord('33b558f0', component.options)
    } else {
      api.reload('33b558f0', component.options)
    }
    module.hot.accept("./AddWorkSamplesToContractor.vue?vue&type=template&id=33b558f0", function () {
      api.rerender('33b558f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddWorkSamplesToContractor.vue"
export default component.exports